import { PERMISSIONS } from '@admin/config/permissions';

export const canManageClaims = () => PERMISSIONS.has('claims:update');
